/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IDataProtectionModuleData } from './data-protection-module.data';
import { IDataProtectionModuleProps } from './data-protection-module.props.autogenerated';
/* import * as Msdyn365 from '@msdyn365-commerce/core'; */

/**
 *
 * DataProtectionModule component
 * @extends {React.PureComponent<IDataProtectionModuleProps<IDataProtectionModuleData>>}
 */
export default class DataProtectionModule extends React.PureComponent<IDataProtectionModuleProps<IDataProtectionModuleData>> {
    public render(): JSX.Element {
        const {
            config: { privacyURL, videoUrl }
        } = this.props;

        return (
            <div className='msc-data-protection'>
                {/*<div className='msc-privacy-policy'>
                <h3 className='msc-privacy-policy heading'><strong>{heading}</strong></h3>
                <div className='msc-privacy-policy privacy-policy'>
                    {dataProtection && <Msdyn365.RichTextComponent text={dataProtection} />}
                </div>
                </div> */}
                <div className='container-fluid'>
                    <div className='row'>
                        <div className='container msc-data-protection'>
                            <div className='row'>
                                <div className='col-12 msc-data-protection-banner'>
                                    <div className='image-holder'>
                                        <img
                                            src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/imageFileData/MDKPm'
                                            title=''
                                            alt='our data protection'
                                        />
                                    </div>
                                    <div className='msc-data-protection-banner_title'>
                                        <h1 className=''>
                                            Our Privacy Policy
                                            <sub>It&apos;s all in the detail</sub>
                                        </h1>
                                    </div>
                                </div>
                                <div className='col-12 msc-data-protection_content'>
                                    <div className='row'>
                                        <div className='offset-lg-1 offset-md-0 col-lg-10 offset-md-12'>
                                            <p>
                                                <strong>
                                                    {' '}
                                                    When it comes to quality, whether it&apos;s immaculate stitching or the perfect birthday
                                                    cake, it’s all about the detail. Getting everything just right is why customers across
                                                    the world trust M&S to make every moment special.
                                                </strong>
                                            </p>
                                            <p>
                                                We believe the most important details, though, are yours - and to keep the information you
                                                share with us as safe as possible, we’ve updated our privacy policy in line with the
                                                requirements set out by the General Data Protection Regulation.
                                            </p>
                                            <p>
                                                The details you share with us help us to bring you our latest offers and inspiration we
                                                think you’ll love. Take a look below for more.
                                            </p>
                                            <div className='msc-data-protection_video-holder'>
                                                {/* <video className='h-100 w-100 d-block bg-dark' preload='metadata' role='none' src='https://www.youtube.com/watch?v=ph63mrIvtWg' playsinline='' /> */}
                                                <iframe
                                                    width='560'
                                                    height='315'
                                                    src={videoUrl}
                                                    frameBorder='0'
                                                    sandbox='allow-scripts allow-same-origin' /* allowfullscreen */
                                                />
                                                {/* <iframe src='https://www.youtube.com/embed/ph63mrIvtWg' allowfullscreen='allowfullscreen' frameBorder='0' sandbox='allow-scripts'>.</iframe> */}
                                            </div>
                                        </div>
                                        <div className='col-12'>
                                            <div className='service-boxes row'>
                                                <div className='col-lg-4 per-box'>
                                                    <div className='icon-holder'>
                                                        <img
                                                            src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/imageFileData/MDNqB'
                                                            alt='special little treats'
                                                        />
                                                    </div>
                                                    <h3>SPECIAL LITTLE TREATS</h3>
                                                    <p>We&apos;ll bring you the latest offers to help you get the best value</p>
                                                </div>
                                                <div className='col-lg-4 per-box'>
                                                    <div className='icon-holder'>
                                                        <img
                                                            src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/imageFileData/MDKPl'
                                                            alt='special little treats'
                                                        />
                                                    </div>
                                                    <h3>THINGS YOU&apos;LL LOVE</h3>
                                                    <p>Getting to know you means we can inspire you with things we think you’ll like.</p>
                                                </div>
                                                <div className='col-lg-4 per-box'>
                                                    <div className='icon-holder'>
                                                        <img
                                                            src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/imageFileData/MDQ1V'
                                                            alt='special little treats'
                                                        />
                                                    </div>
                                                    <h3>SHOP YOUR WAY</h3>
                                                    <p>How you shop helps us tailor our website to better suit you.</p>
                                                </div>
                                                <div className='col-lg-4 per-box'>
                                                    <div className='icon-holder'>
                                                        <img
                                                            src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/imageFileData/MDQ1U'
                                                            alt='special little treats'
                                                        />
                                                    </div>
                                                    <h3>A SMOOTH SERVICE</h3>
                                                    <p>
                                                        In order to make certain services available to you, we may need to share your
                                                        personal data with some of our service partners, all of whom meet the same high
                                                        standards when it comes to customer data privacy
                                                    </p>
                                                </div>
                                                <div className='col-lg-4 per-box'>
                                                    <div className='icon-holder'>
                                                        <img
                                                            src='https://images-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/imageFileData/MDQ1W'
                                                            alt='special little treats'
                                                        />
                                                    </div>
                                                    <h3>HERE TO HELP</h3>
                                                    <p>
                                                        Should you need assistance, our customer service team will be able to access your
                                                        information to speed up the process.
                                                    </p>
                                                </div>
                                                <div className='col-lg-4 per-box'>
                                                    <div className='icon-holder'>
                                                        <img
                                                            src='https://files-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/binary/MDsCz'
                                                            alt='special little treats'
                                                        />
                                                    </div>
                                                    <h3>LOOKING AFTER YOU</h3>
                                                    <p>
                                                        So you can shop with confidence, we use information to confirm your identity and
                                                        help protect you against fraud.
                                                    </p>
                                                </div>
                                            </div>
                                            <p className='mt-4'>
                                                If you would like to check which details you have shared with us, and your marketing
                                                preferences, please <a href=''>click here</a>
                                            </p>
                                            <div className='lined-header'>
                                                <h4>
                                                    <a href={privacyURL}>
                                                        <span>
                                                            Full privacy policy{' '}
                                                            <img
                                                                src='https://files-eu-prod.cms.commerce.dynamics.com/cms/api/scwrkbhfhd/binary/MDsCz'
                                                                alt='privacy policy'
                                                            />
                                                        </span>
                                                    </a>
                                                </h4>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
